import { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { logEvent } from '../logEvent';

export function SongTitle({ songTitle, albumTitle, i }) {
  return (
    <article key={`${songTitle}TitleDiv`} className='songTitleDiv'>
      <span className='rightAngle'>∟</span> {i + 1}.&nbsp;
      <Link to={`/song/${albumTitle}/${songTitle.replaceAll(' ', '_')}`}>
        {songTitle}
      </Link>
    </article>
  );
}

export default function Release({ title, year, songs, comments }) {
  const audioRef = useRef(null);
  const [audioAvailable, setAudioAvailable] = useState(false);
  const albumTitle = title.replaceAll(' ', '_');
  const audioSrc = `files/audio/${title}.mp3`;

  // Check if medley audio exists
  useEffect(() => {
    const checkAudio = async () => {
      try {
        const res = await fetch(audioSrc, { method: 'HEAD' });
        const isAudio = res.headers.get('Content-Type')?.startsWith('audio');

        if (res.ok && isAudio) setAudioAvailable(true);
      } catch (e) {
        console.warn(`Audio file not found for ${title}!`);
      }
    };
    checkAudio();
  }, [audioSrc, title]);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = 0.3;
    }
  }, [audioAvailable]);

  return (
    <article>
      <p className='releaseSymbol'>❉</p>

      <b className='releaseTitle'>
        {title} ({year})
      </b>
      <br />
      {songs?.map((s, i) => (
        <SongTitle
          key={s.title}
          songTitle={s.title}
          albumTitle={albumTitle}
          i={i}
        />
      ))}

      <p className='commentText' dangerouslySetInnerHTML={{ __html: comments }} />

      <p className='medleyText'>
        {audioAvailable ? (
          <><span className='titleInMedley'>{title}</span> medley/clip:</>
        ) : (
          <><span className='titleInMedley'>{title}</span> medley coming soon.</>
        )}
      </p>

      <audio
        ref={audioRef}
        controls
        src={audioAvailable ? audioSrc : undefined}
        style={{
          opacity: audioAvailable ? 1 : 0.5,
          pointerEvents: audioAvailable ? 'auto' : 'none',
          cursor: audioAvailable ? 'auto' : 'not-allowed',
        }}
        onPlay={() => logEvent('audio_play', audioSrc)}
      >
        Your browser does not support the audio element.
      </audio>
    </article>
  );
}
